// import { useErrorBoundary } from 'react-error-boundary';

/** @todo see if we really need this! */
export const ErrorBoundaryFallback = ({ error }: { error: { message: string } }) => {
    // const { resetBoundary } = useErrorBoundary();
    return <div className="r-bg-danger-400 r-p-4 r-text-white">There was an error {error.message}</div>;
};
